<template>
    <div class="col-xl-3 col-lg-3">
        <div class="row">
            <div class="col-xl-12 col-sm-6 col-lg-12">
                <div class="card value-chart bg-primary">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-6">
                                <div class="round-progress knob-block text-center">
                                    <div class="progress-circle">
                                        <div id="ordervalue"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="valuechart-detail">
                                    <div>
                                        <p>Our Sale Value </p>
                                        <h2>$7454.25</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div><span class="badge badge-primary">New</span>
                </div>
            </div>
            <div class="col-xl-12 col-sm-6 col-lg-12">
                <div class="card value-chart stock-value bg-secondary">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-6">
                                <div class="stock-value" id="stock-value">
                                    <apexchart type="bar" height="155" :options="stock.options" :series="stock.series">
                                    </apexchart>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="valuechart-detail">
                                    <div>
                                        <p>Today Value</p>
                                        <h2>$5263.04 </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div><span class="badge badge-primary">Hot </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import beyoLine from "@/mixins/beyoLine"
var Knob = require('knob');
var ordervalue = Knob({
    value: 60,
    angleOffset: 0,
    className: 'knob1',
    thickness: 0.3,
    width: 140,
    height: 140,
    fgColor: '#534686',
    bgColor: '#C4C4C4'
});

export default {
    name: 'salesPage',
    mixins: [beyoLine],
    data() {
        return {
            someValue: 20,
        }
    },
    mounted() {
        document.getElementById('ordervalue').append(ordervalue);
    }
}
</script>
